import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
Vue.prototype.$store = store

const store = new Vuex.Store({
  state: {
    lang: 'En',
    baseSrc: '/static/image/',
    footToHome: 0,
    scrollTop: 0,
    clientHeight: 0,
    innerWidth: 0,
    forumTypes: [],
    searchListBoolean: false,
    successNum: 0,
    banners: {},
    openAd: false,
    labels: [],
    headList:[],
    headIndex:0,
    leftIndex:0,
    ExhibitDetail:{},
    FunctionModule:[],
    pageName:{},
    showBigIconIndex: -1,
    bigIcons: [],
    showSystem: false,
    showShare: false
  },
  mutations: {
    setPageName(state, v) {
      window.localStorage.setItem('pageName',JSON.stringify(v))
      state.pageName = v
    },
    setFunctionModule(state, v) {
      window.localStorage.setItem('FunctionModule',JSON.stringify(v))
      state.FunctionModule = v
    },
    setHeadIndex(state, v) {
      window.localStorage.setItem('headIndex',v)
      state.headIndex = v
    },
    setLeftIndex(state, v) {
      window.localStorage.setItem('leftIndex',v)
      state.leftIndex = v
    },
    setExhibitDetail(state, v) {
      window.localStorage.setItem('ExhibitDetail',JSON.stringify(v))
      state.ExhibitDetail = v
    },
    setHeadList(state, v) {
      window.localStorage.setItem('headList',JSON.stringify(v))
      state.headList = v
    },
    setLang(state, v) {
      state.lang = v
    },
    setFootToHome(state) {
      state.footToHome += 1
    },
    setTop(state, v) {
      state.scrollTop = v
    },
    setHeight(state, v) {
      state.clientHeight = v
    },
    setWidth(state, v) {
      state.innerWidth = v
    },
    setForumType(state, v) {
      state.forumTypes = v
    },
    setSearchList(state, v) {
      state.searchListBoolean = v
    },
    setSuccessNum(state) {
      state.successNum++
    },
    clearSuccessNum(state) {
      state.successNum = 0
    },
    setBanners(state, v) {
      state.banners = v
    },
    setOpenAd(state, v) {
      state.openAd = v
    },
    setLabels(state, v) {
      state.labels = v
    },
    setShowBigIcon(state, v) {
      state.showBigIconIndex = v
    },
    setBigIcons(state, v) {
      state.bigIcons = v
    },
    setShowSystem(state, v) {
      state.showSystem = v
    },
    setshowShare(state, v) {
      state.showShare = v
    },
  }
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js